<template>
    <div class="info-edit">
        <!-- 头部 -->
        <head-bar title="我的预付货款" :fixed="true">
            <template v-slot:right>
                <div class="head-right-slot">
                    <router-link to="/">
                        <i class="head-home-icon"></i>
                    </router-link>
                </div>
            </template>
        </head-bar>
        <!-- 内容 -->
        <div class="main_content">
            <!-- 未开通 -->
            <div
                class="not_opened_container"
                v-if="
                    walletInfo.walletState ==
                        walletStatusMap.wallet_status_not_opened
                "
            >
                <div class="wallet_info">
                    <div class="amount_text">
                        <i class="money_icon">¥</i>&nbsp;<span>0.00</span>
                    </div>
                    <div class="balance_text">
                        <span>预付货款余额</span>
                    </div>
                    <div class="open_wallet" @click="goToAgreementPage">
                        <span>开通预付货款</span>
                    </div>
                </div>
                <div class="status_info">
                    <span>账户状态:未开通</span>
                </div>
                <div class="menu_item">
                    <div class="meun_left">
                        <span>预付款协议</span>
                    </div>
                    <div class="meun_right"></div>
                </div>
            </div>
            <!-- 未开通 -->
            <!-- 开通 -->
            <div
                class="wallet_container"
                v-if="
                    walletInfo.walletState !==
                        walletStatusMap.wallet_status_not_opened
                "
            >
                <div class="wallet_info">
                    <div class="amount_text">
                        <i class="money_icon">¥</i>&nbsp;
                        <span>{{ walletInfo.totalBalance }}</span>
                    </div>
                    <div class="balance_text">
                        <span>预付货款余额</span>
                    </div>
                    <div class="button_group">
                        <span
                            class="button_item margin_right_15"
                            :class="{ disabled: !isWalletRecharge }"
                            @click="goToRechargePage"
                            >预付货款</span
                        >
                        <span
                            class="button_item"
                            :class="{ disabled: !isEditWalletInfo }"
                            @click="goToRefundPage"
                            >退回货款</span
                        >
                    </div>
                </div>
                <div class="status_info">
                    <div class="status_info_item">
                        <span
                            >账户状态:&nbsp;{{
                                walletInfo.walletStateDesc
                            }}</span
                        >
                        <span class="lock_text" v-if="walletInfo.lockRemark"
                            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                                walletInfo.lockRemark
                            }}</span
                        >
                    </div>
                    <div class="status_info_item">
                        <span>公司名称:&nbsp;{{ walletInfo.companyName }}</span>
                    </div>
                    <div class="status_info_item">
                        <span>公司税号:&nbsp;{{ walletInfo.taxNo }}</span>
                    </div>
                </div>
                <div class="meun_list">
                    <div class="menu_item border_bottom ">
                        <div
                            class="meun_left"
                            :class="{ disabled: !isEditWalletInfo }"
                            @click="goToPasswordUpdatePage"
                        >
                            <span>修改支付密码</span>
                        </div>
                        <div class="meun_right"></div>
                    </div>
                    <div
                        class="menu_item border_bottom "
                        :class="{ disabled: !isEditWalletCompanyInfo }"
                        @click="goToCompanyUpdatePage"
                    >
                        <div class="meun_left">
                            <span>更改预付货款公司</span>
                        </div>
                        <div class="meun_right"></div>
                    </div>
                    <div
                        class="menu_item border_bottom"
                        :class="{ disabled: !isEditWalletInfo }"
                        @click="goToCreditUpdatePage"
                    >
                        <div class="meun_left">
                            <span>更改限额</span>
                        </div>
                        <div class="meun_right"></div>
                    </div>
                    <div class="menu_item" @click="goToAgreementPage">
                        <div class="meun_left">
                            <span>预付款协议</span>
                        </div>
                        <div class="meun_right"></div>
                    </div>
                </div>
                <div class="transaction_record" @click="goToTransactionRecord">
                    <div class="menu_item">
                        <div class="meun_left">
                            <span>交易记录</span>
                        </div>
                        <div class="meun_right"></div>
                    </div>
                </div>
            </div>
            <!-- 开通 -->
        </div>
    </div>
</template>

<script>
import HeadBar from "@/components/HeadBar";
import Vue from "vue";
import { Field, Button, Switch, Cell, Dialog } from "vant";

import {
    wallet_status_not_opened,
    wallet_status_feoze,
    wallet_status_unsubscribe,
    wallet_status_lock,
    wallet_status_normal,
    wallet_status_insufficient,
} from "../../../definition/status/wallet";

Vue.use(Field);
Vue.use(Button);
Vue.use(Switch);
Vue.use(Cell);
Vue.use(Dialog);

export default {
    components: { HeadBar },
    data() {
        return {
            /* 开票类型列表数据 */
            walletInfo: {
                walletState: wallet_status_not_opened,
                cashBalance: 0,
                totalBalance: 0,
                lockRemark: "",
            },
            walletStatusMap: {
                wallet_status_not_opened,
            },
            isLoadEnd: false,
        };
    },
    created() {
        this.getWalletInfo();
    },
    methods: {
        /**
         * @description 获取用户钱包信息
         */
        getWalletInfo() {
            this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            const url = this.$api.userApi.queryWalletInfo;
            this.isLoadEnd = false;
            this.$axios
                .post(url, {})
                .then((res) => {
                    let { data: walletInfo = {} } = res;
                    this.walletInfo = walletInfo;
                })
                .finally(() => {
                    this.$toast.clear();
                    this.isLoadEnd = true;
                });
        },
        /**
         * @description 注册钱包
         */
        goToRegisterPage() {
            if (!this.isLoadEnd) return;
            this.$router.push({
                path: "/user/wallet/apply",
            });
        },
        // 跳转到充值
        goToRechargePage() {
            if (!this.isWalletRecharge) return;
            this.$router.push({
                path: "/user/wallet/recharge",
            });
        },
        //跳转到退款页面
        goToRefundPage() {
            if (!this.isEditWalletInfo) return;
            this.$router.push({
                path: "/user/wallet/refund",
            });
        },
        //跳转去密码修改页
        goToPasswordUpdatePage() {
            if (!this.isEditWalletInfo) return;
            this.$router.push({
                path: "/user/wallet/password",
            });
        },
        //跳转去修改公司页面
        goToCompanyUpdatePage() {
            if (!this.isEditWalletCompanyInfo) return;
            this.$router.push({
                path: "/user/wallet/company",
            });
        },
        //跳转去修改限额页面
        goToCreditUpdatePage() {
            this.$router.push({
                path: "/user/wallet/credit",
            });
        },
        //跳转去交易记录
        goToTransactionRecord() {
            this.$router.push({
                path: "/user/wallet/transactionList",
            });
        },
        //跳转去协议
        goToAgreementPage() {
            this.$router.push({
                path: "/user/wallet/agreement",
            });
        },
    },
    computed: {
        //是否可以编辑其他信息
        isEditWalletInfo: function() {
            let { walletState } = this.walletInfo;
            return (
                walletState == wallet_status_normal ||
                walletState == wallet_status_lock
            );
        },
        //是否可以重新编辑公司
        isEditWalletCompanyInfo() {
            let { walletState, totalBalance } = this.walletInfo;
            return (
                (walletState == wallet_status_normal ||
                    walletState == wallet_status_lock) &&
                totalBalance <= 0
            );
        },
        //是否可以充值
        isWalletRecharge() {
            let { walletState } = this.walletInfo;
            return (
                walletState != wallet_status_feoze &&
                walletState != wallet_status_not_opened
            );
        },
    },
};
</script>

<style lang="less" scoped>
.info-edit {
    .head-right-slot {
        height: 100%;
        text-align: right;
        padding-right: 20px;

        i {
            *display: inline;
            display: inline-block;
            zoom: 1;
            width: 60px;
            height: 100%;
            background-repeat: no-repeat;
            background-size: 48px;
            background-position: center;
            margin: 0 10px;

            &.head-search-icon {
                background-image: url(../../../public/images/head/head-search-icon.png);
            }

            &.head-home-icon {
                background-image: url(../../../public/images/head/head-home-icon.png);
            }
        }
    }

    .main_content {
        padding-top: 20px;
        .menu_item {
            padding: 0 40px;
            width: 670px;
            height: 80px;
            background-color: #fff;
            line-height: 80px;
            font-size: 28px;
            color: #666;
            &.border_bottom {
                border-bottom: 1px solid #f6f6f6;
            }
            &.margin_top_20 {
                margin-top: 20px;
            }
            &.disabled {
                .meun_left {
                    color: #999;
                }
            }
            .meun_left {
                float: left;
                width: 335px;
                height: 80px;
            }
            .meun_right {
                float: right;
                padding-right: 40px;
                width: 295px;
                height: 80px;
                background-image: url("../../../public/images/common/arrow-right-icon.png");
                background-position: center right;
                background-repeat: no-repeat;
                background-size: 40px;
            }
        }
        .not_opened_container {
            margin: 90px 0 0 0;
            width: 750px;
            > .wallet_info {
                height: 300px;
                background-color: #fff;
                border-bottom: 1px solid #f6f6f6;
                > .amount_text {
                    padding: 70px 0 0 0;
                    font-size: 60px;
                    font-weight: 600;
                    color: #333;
                    text-align: center;
                    > .money_icon {
                        font-size: 40px;
                    }
                }
                > .balance_text {
                    height: 48px;
                    font-size: 24px;
                    font-weight: 400;
                    text-align: center;
                    color: #666666;
                }
                > .open_wallet {
                    margin: 0 auto;
                    width: 380px;
                    height: 70px;
                    background-color: #4bc227;
                    border-radius: 36px;
                    font-size: 28px;
                    line-height: 70px;
                    text-align: center;
                    color: #fff;
                }
            }
            > .status_info {
                padding: 0 40px;
                height: 80px;
                background-color: #fff;
                line-height: 80px;
                font-size: 28px;
                color: #666;
            }
        }
        .wallet_container {
            margin: 90px 0 0 0;
            > .wallet_info {
                height: 300px;
                background-color: #fff;
                border-bottom: 1px solid #f6f6f6;
                > .amount_text {
                    padding: 70px 0 0 0;
                    font-size: 60px;
                    font-weight: 600;
                    color: #333;
                    text-align: center;
                    > .money_icon {
                        font-size: 40px;
                    }
                }
                > .balance_text {
                    height: 48px;
                    font-size: 24px;
                    font-weight: 400;
                    text-align: center;
                    color: #666666;
                }
                > .button_group {
                    text-align: center;
                    .button_item {
                        *display: inline;
                        display: inline-block;
                        zoom: 1;
                        padding: 0 70px;
                        height: 58px;
                        border-radius: 38px;
                        border: 1px solid #dedede;
                        font-size: 24px;
                        line-height: 60px;
                        font-weight: 400;
                        text-align: center;
                        color: #333333;
                        &.margin_right_15 {
                            margin-right: 15px;
                        }

                        &.disabled {
                            color: #999;
                            border-color: #999;
                        }
                    }
                }
            }
            > .status_info {
                padding: 30px 40px;
                background-color: #fff;
                > .status_info_item {
                    margin-bottom: 5px;

                    font-size: 28px;
                    line-height: 40px;
                    color: #666666;
                    &:last-child {
                        margin-bottom: 0;
                    }

                    .lock_text {
                        padding-left: 10px;
                        color: #ff451f;
                    }
                }
            }
            > .meun_list {
                margin: 20px 0 0 0;
            }
            > .transaction_record {
                margin: 20px 0;
                > .transaction_list {
                    > .transaction_item {
                        padding: 40px;
                        width: 670px;
                        border-top: 1px solid #f6f6f6;
                        background-color: #fff;
                        .company_info {
                            position: relative;
                            height: 55px;
                            font-size: 28px;
                            line-height: 55px;
                            font-weight: 400;
                            color: #333333;
                            .consumption_text {
                                position: absolute;
                                z-index: 10;
                                top: 0;
                                right: 0;
                                height: 55px;
                                font-size: 28px;
                                line-height: 55px;
                                font-weight: 400;
                                color: #333333;
                            }
                        }
                        .common_info {
                            position: relative;
                            height: 55px;
                            .common_info_line {
                                font-size: 28px;
                                height: 55px;
                                line-height: 55px;
                                font-weight: 400;
                                color: #999;
                            }
                            .common_info_left {
                                float: left;
                                width: 50%;
                            }
                            .common_info_right {
                                float: right;
                                width: 50%;
                                text-align: right;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
